require("././dist/css/bootstrap.css");
module.exports = require("././dist/js/bootstrap.js");
require("././dist/fonts/glyphicons-halflings-regular.eot");
require("././dist/fonts/glyphicons-halflings-regular.svg");
require("././dist/fonts/glyphicons-halflings-regular.ttf");
require("././dist/fonts/glyphicons-halflings-regular.woff");


//////////////////
// WEBPACK FOOTER
// bootstrap (bower component)
// module id = 439
// module chunks = 0